import React from "react";
import 'bootstrap/dist/css/bootstrap.css';
import Mainn from "./MyComponents";
import './App.css'

const App:React.FC =()=>{
    return (
        <div>
            {/* <Nav2/>
            <Hero/>
             */}
            <Mainn/>
        </div>
    ) 
}
export default App;